<template>
    <div class="popup" :class="classObj" v-if="isLogin">
        <van-popup :value="show" @click-overlay="close" @open="openPop">
            <div class="content">
                <div class="header">
                    <div>{{ $t("BetsHistory.BetsHistory") }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div class="box">
                    <div class="chose_box">
                        <div class="date_box">
                            <a-date-picker mode="date" v-model="nowDate" :format="'YYYY/MM/DD'" :open="open"
                                :getCalendarContainer="getCalendarContainer" @openChange="openChange" @change="onChange"
                                :defaultValue="todayDate" :allowClear="false" :showToday="false" />
                        </div>
                    </div>
                    <div class="list_content">
                        <van-list v-model="loading" :finished="!hasMore" loading-text="" @load="getBetRecordsList"
                            class="list" offset="50" :immediate-check=false v-if="list.length !== 0">
                            <div class="list_item" v-for="(item, index) in list" :key="index">
                                <div>
                                    <div>
                                        {{ $t("MyProfile.ID") }}:{{ item.transactionId }}
                                    </div>
                                    <div>
                                        {{ item.createTime }}
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        {{ item.gameName }}
                                    </div>
                                    <div>
                                        {{ formatCurrency(item.winAmt || 0) }}
                                    </div>
                                </div>
                            </div>
                        </van-list>
                        <div class="empty" v-else>
                            <img src="@/assets/common/empty.avif" alt="" class="empty_img">
                            <div>{{ $t("lang.NoData") }}</div>
                        </div>
                        <div v-if="loading && list.length !== 0" class="loading">
                            <a-spin>
                                <a-icon slot="indicator" type="loading" spin />
                            </a-spin>
                            {{ $t("lang.Loading") }}
                        </div>
                        <div v-if="!hasMore && list.length !== 0" class="loading">
                            {{ $t("lang.NoMore") }}
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {
    getBetRecordsList
} from '@/api/records'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
    name: 'betHistory',
    components: {},
    data() {
        return {
            firstLoaded: true,
            dateFormat: 'YYYY/MM/DD',
            todayDate: '',
            nowDate: '',
            open: false,
            list: [],
            pageSize: 10,
            pageNo: 0,
            loading: false,
            hasMore: true
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        show: {
            get() {
                return this.$store.getters.isShowBetHistoryPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() {
        this.todayDate = moment()
    },
    methods: {
        moment,
        close() {
            this.$store.dispatch('user/setIsShowBetHistoryPopup', false)
        },
        openPop() {
            if (this.firstLoaded) {
                this.init()
            }
        },
        init() {
            this.pageSize = 10
            this.pageNo = 0
            this.list = []
            this.nowDate = this.todayDate
            this.getBetRecordsList()
        },
        async getBetRecordsList() {
            this.pageNo++
            const curData = {
                startTime: '',
                endTime: '',
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }
            // console.log(this.nowDate)
            if (this.nowDate) {
                curData.startTime = moment(this.nowDate).format('YYYY-MM-DD 00:00:00')
                curData.endTime = moment(this.nowDate).format('YYYY-MM-DD 23:59:59')
            }
            this.loading = true
            const {
                result,
                code
            } = await getBetRecordsList(curData)
            this.loading = false
            if (code === 0) {
                this.list = [...this.list, ...result.list]
                this.pages = result.pages
                this.hasMore = Number(result.total) > this.list.length
                this.firstLoaded = false
            }
        },
        onChange(value, dateString) {
            // console.log('Selected Time: ', value)
            // console.log('Formatted Selected Time: ', dateString)
            this.nowDate = value
            this.pageSize = 10
            this.pageNo = 0
            this.list = []
            this.getBetRecordsList()
        },
        openChange(status) {
            if (status) {
                this.open = true
            } else {
                this.open = false
            }
        },
        getCalendarContainer() {
            return document.querySelector('.date_box')
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile {

        .content {
            width: 100% !important;
            height: 100% !important;
        }

        .van-popup {
            &.van-popup--center {
                top: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                height: 100% !important;
            }

            .content {
                background: #15161c;
                width: 100%;
                height: 100vh;

                .header {
                    height: 1.12rem;
                    padding: 0 .3rem;
                    background: #191b21;

                    &>div:first-child {
                        font-size: .32rem;
                    }

                    .close {
                        font-size: .32rem;
                    }
                }

                .box {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding: .3rem;
                }

                .chose_box {

                    .date_box {
                        text-align: left;

                        ::v-deep .ant-calendar-picker-input {
                            &.ant-input {
                                background: #23262f;
                                padding: .22rem .24rem;
                                height: max-content;
                                color: #ffffff;
                                border-radius: .24rem;
                                font-size: .24rem;
                                border: 0;
                            }
                        }

                        ::v-deep .ant-calendar-picker-icon {
                            font-size: .32rem;
                        }
                    }
                }

                .list_content {
                    margin: .2rem 0;
                    flex: 1;

                    .list {
                        padding: .2rem;
                        row-gap: .2rem;

                        .list_item {
                            padding: .2rem;
                            background: #2a2f39;
                            border-radius: .24rem;

                            >div {
                                display: flex;
                                justify-content: space-between;
                                font-size: .26rem;

                                &:first-child {
                                    margin-bottom: .04rem;

                                    >div {

                                        &:last-child {
                                            font-size: .22rem;
                                        }
                                    }
                                }

                                &:last-child {
                                    >div {
                                        &:first-child {
                                            font-size: .28rem;
                                        }

                                        &:last-child {
                                            color: #45d91e;
                                        }
                                    }
                                }
                            }

                            ::v-deep .van-loading {
                                display: none;
                            }
                        }
                    }

                    .loading {
                        font-size: .28rem;
                    }

                    .empty {
                        font-size: .3rem;

                        .empty_img {
                            width: 2.8rem;
                        }
                    }
                }
            }
        }
    }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            background: $bg-popup-color;
            width: 800px;
            height: 700px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                height: 76px;
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: 20px;
                    font-weight: bold;
                    color: #fff;
                }

                .close {
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: #ffffff;
                        rotate: -180deg;
                    }
                }
            }

            .box {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 30px 40px;
            }

            .chose_box {

                .date_box {
                    text-align: left;

                    // color: #ffffff;
                    // padding: 15px 12px;
                    ::v-deep .ant-calendar {
                        background: $bg-box-color;
                    }

                    ::v-deep .ant-calendar-picker {
                        width: 50%;
                    }

                    ::v-deep .ant-calendar-input {
                        color: #ffffff;
                        background: transparent !important;
                    }

                    ::v-deep .ant-calendar-picker-input {
                        &.ant-input {
                            background: #2a2f39;
                            padding: 12px;
                            height: max-content;
                            color: #ffffff;
                            border-radius: .24rem;
                            font-size: 15px;
                            border: 0;
                        }
                    }

                    ::v-deep .ant-calendar-picker-icon {
                        color: #4c5d7a;
                        font-size: 16px;
                    }

                    ::v-deep .ant-calendar-picker-container {
                        color: #ffffff;
                    }

                    ::v-deep .ant-calendar-today {
                        .ant-calendar-date {
                            border-color: transparent;
                        }
                    }

                    ::v-deep .ant-calendar-selected-day {
                        .ant-calendar-date {
                            background: $bg-btn-color;
                            border-radius: 50%;
                        }
                    }

                    ::v-deep .ant-calendar-date {
                        color: #ffffff;
                    }

                    ::v-deep .ant-calendar-month-select {
                        color: #ffffff;
                    }

                    ::v-deep .ant-calendar-year-select {
                        color: #ffffff;
                    }
                }
            }

            .list_content {
                background: $bg-list-color;
                border-radius: .24rem;
                margin-top: 10px;
                flex: 1;

                .list {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    row-gap: 10px;

                    .list_item {
                        padding: 15px;
                        background: #2a2f39;
                        border-radius: .24rem;

                        >div {
                            display: flex;
                            justify-content: space-between;
                            font-size: 16px;

                            &:first-child {
                                margin-bottom: 2px;

                                >div {
                                    &:first-child {
                                        color: #ffffff;
                                    }

                                    &:last-child {
                                        font-size: 15px;
                                        color: #ffffff;
                                    }
                                }
                            }

                            &:last-child {
                                >div {
                                    &:first-child {
                                        font-size: 18px;
                                        color: #ffffff;
                                        font-weight: bold;
                                    }

                                    &:last-child {
                                        color: #45d91e;
                                    }
                                }
                            }
                        }

                        ::v-deep .van-loading {
                            display: none;
                        }
                    }
                }

                .loading {
                    font-size: 14px;
                    color: $font-sub-color;
                }

                .empty {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: $font-sub-color;
                    font-size: 16px;

                    .empty_img {
                        width: 170px;
                        object-fit: contain;
                    }
                }
            }
        }
    }
}

.van-popup {
    .content {
        .header .close {
            color: #d7b37d;
        }

        .chose_box .date_box {
            ::v-deep .ant-calendar-picker-input.ant-input {
                background: linear-gradient(180deg, rgba(129, 11, 16, .96) 0%, rgba(94, 6, 10, .98) 100%);
                border: 1px solid rgba(205, 137, 61, .28);
            }

            ::v-deep .ant-calendar-picker-icon,
            ::v-deep .ant-calendar-picker-container {
                color: #d7b37d;
            }
        }

        .list_content .list .list_item {
            background: linear-gradient(180deg, rgba(129, 11, 16, .96) 0%, rgba(94, 6, 10, .98) 100%);
            border: 1px solid rgba(205, 137, 61, .24);

            > div:first-child > div:last-child {
                color: #d7b37d;
            }

            > div:last-child > div:last-child {
                color: #f0c05a;
            }
        }
    }
}

.popup {
    .van-popup {
        .content {
            background: linear-gradient(180deg, rgba(88, 7, 11, .98) 0%, rgba(57, 4, 7, .99) 100%);
            border: 1px solid rgba(212, 152, 76, .2);
            box-shadow: 0 .12rem .28rem rgba(35, 3, 4, .34);

            .header {
                background: linear-gradient(180deg, rgba(169, 20, 25, .98) 0%, rgba(130, 9, 15, .98) 58%, rgba(100, 6, 11, .99) 100%);
                border-bottom: 1px solid rgba(205, 137, 61, .18);

                >div:first-child {
                    color: #fff4dc;
                }

                .close {
                    color: #f0d8a0;
                }
            }

            .box {
                background: transparent;
            }

            .chose_box .date_box {
                ::v-deep .ant-calendar {
                    background: linear-gradient(180deg, rgba(96, 8, 12, .99) 0%, rgba(66, 5, 8, .99) 100%);
                    border-color: rgba(205, 137, 61, .24);
                }

                ::v-deep .ant-calendar-picker-input.ant-input {
                    background: linear-gradient(180deg, rgba(136, 14, 18, .98) 0%, rgba(98, 7, 11, .98) 100%);
                    border: 1px solid rgba(210, 147, 67, .24);
                    color: #fff0d6;
                }

                ::v-deep .ant-calendar-picker-icon,
                ::v-deep .ant-calendar-picker-container,
                ::v-deep .ant-calendar-input,
                ::v-deep .ant-calendar-month-select,
                ::v-deep .ant-calendar-year-select {
                    color: #d8bc8a;
                }

                ::v-deep .ant-calendar-date {
                    color: #fff0d6;

                    &:hover {
                        background: rgba(217, 166, 60, .16);
                    }
                }
            }

            .list_content {
                background: rgba(74, 5, 8, .76);
                border: 1px solid rgba(205, 137, 61, .18);

                .list .list_item {
                    background: linear-gradient(180deg, rgba(129, 11, 16, .98) 0%, rgba(90, 6, 10, .98) 100%);
                    border: 1px solid rgba(205, 137, 61, .22);

                    >div:first-child >div:first-child,
                    >div:last-child >div:first-child {
                        color: #fff1dc;
                    }

                    >div:first-child >div:last-child {
                        color: #d8bc8a;
                    }

                    >div:last-child >div:last-child {
                        color: #f1c75d;
                    }
                }

                .loading,
                .empty {
                    color: #d8bc8a;
                }
            }
        }
    }

    &.mobile {
        .van-popup .content {
            background: linear-gradient(180deg, rgba(88, 7, 11, .99) 0%, rgba(57, 4, 7, 1) 100%);

            .header {
                background: linear-gradient(180deg, rgba(122, 76, 20, .98) 0%, rgba(92, 53, 10, .99) 100%);
            }

            .list_content {
                background: rgba(74, 5, 8, .78);
            }
        }
    }
}

.popup {
    .van-popup {
        .content {
            background:
                radial-gradient(circle at 18% 0, rgba(255, 210, 74, .18) 0, rgba(255, 210, 74, 0) 32%),
                linear-gradient(180deg, rgba(106, 49, 8, .99) 0%, rgba(43, 15, 1, 1) 100%) !important;
            color: var(--theme-text) !important;
            border: 1px solid rgba(255, 198, 83, .36) !important;
            box-shadow: inset 0 1px 0 rgba(255, 242, 193, .12), 0 .12rem .32rem rgba(25, 7, 0, .36) !important;

            .header {
                background: $bg-popup-navbar-color !important;
                border-bottom: 1px solid rgba(255, 206, 115, 0.16) !important;

                >div:first-child,
                .close {
                    color: #ffffff !important;
                }
            }

            .chose_box .date_box {
                ::v-deep .ant-calendar {
                    background: linear-gradient(180deg, rgba(96, 43, 16, 0.99) 0%, rgba(69, 33, 10, 0.99) 100%) !important;
                    border-color: rgba(255, 178, 95, 0.22) !important;
                }

                ::v-deep .ant-calendar-picker-input.ant-input {
                    background: $bg-btn-bot-color !important;
                    border: 1px solid rgba(255, 228, 95, 0.24) !important;
                    color: #ffffff !important;
                }

                ::v-deep .ant-calendar-picker-icon,
                ::v-deep .ant-calendar-picker-container,
                ::v-deep .ant-calendar-input,
                ::v-deep .ant-calendar-month-select,
                ::v-deep .ant-calendar-year-select {
                    color: #fffae1 !important;
                }
            }

            .list_content {
                background: rgba(31, 18, 8, .78) !important;
                border: 1px solid rgba(255, 197, 115, 0.14) !important;

                .list .list_item {
                    background: $bg-box-color !important;
                    border: 1px solid rgba(255, 194, 95, 0.18) !important;

                    >div:first-child >div:first-child,
                    >div:last-child >div:first-child {
                        color: #ffffff !important;
                    }

                    >div:first-child >div:last-child {
                        color: #fff8d5 !important;
                    }

                    >div:last-child >div:last-child {
                        color: #f1c75d !important;
                    }
                }

                .loading,
                .empty {
                    color: #fff8d5 !important;
                }
            }
        }
    }
}
</style>
